module.exports = __webpack_public_path__ + "img/advertising_01.fd839c52.png";